'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'repeat';
var width = 512;
var height = 512;
var aliases = [128257];
var unicode = 'f363';
var svgPathData = 'M0 224L0 96 0 64l32 0 288 0 0-64 32 0 96 96-96 96-32 0 0-64L64 128l0 96 0 32L0 256l0-32zm512 64l0 128 0 32-32 0-288 0 0 64-32 0L64 416l96-96 32 0 0 64 256 0 0-96 0-32 64 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRepeat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;